import sc from 'styled-components';
import {Layout, TextArea, UnifonTheme} from '@phonectas/unifon-ui-kit';


interface StyledTextAreaProps {
  maxLength?: number;
}

export const StyledCatalogColumns = sc.div`
	width: 100%;
	flex-grow: 1;
	box-sizing: border-box;
`;

export const StyledHeaderContent = sc(Layout)`
	position: relative;
`;

export const StyledQueueCardTitle = sc(Layout)`
	cursor: pointer;
`;

export const StyledTelLink = sc.a<{ theme?: UnifonTheme }>`
	color: ${({theme}) => theme.palette.primary};
	text-decoration: none;
`;

export const StyledTextArea = sc(TextArea).attrs<StyledTextAreaProps>(props => (
	props.maxLength !== undefined ? {maxLength: props.maxLength} : {}
))<StyledTextAreaProps>`
    height: 250px;
    width: 450px;
`;

export const StyledLeftColumn = sc(Layout)`
	width: 450px;
`;

export const StyledRightColumn = sc(Layout)`
	width: 370px;
`;

export const StyledLeftMainColumn = sc(Layout)`
	min-width: 55%;
`;
